import { ApiError } from '@/api/client';
import { showErrorToast } from '@/lib/toasts';

/** Error toast of a failed Access write: the API's problem (code and message) or, for anything else, `fallbackTitle`. */
export function apiFailureToast(e: unknown, fallbackTitle: string): { title: string; description?: string } {
  return e instanceof ApiError ? { title: e.toastTitle, description: `${e.code} · ${e.message}` } : { title: fallbackTitle };
}

/** Shows the toast of a failed Access write (see `apiFailureToast`). */
export const showApiFailure = (e: unknown, fallbackTitle: string): void => showErrorToast(apiFailureToast(e, fallbackTitle));
